export default "__VITE_ASSET__5WbVtJ$H__"